import Slider from "../components/slider";
import image1 from "../assets/img/help/1.png";
import image2 from "../assets/img/help/2.png";
import image3 from "../assets/img/help/3.png";
import image4 from "../assets/img/help/4.png";
import image5 from "../assets/img/help/5.png";
import image6 from "../assets/img/help/6.png";
import image7 from "../assets/img/help/7.png";
import image8 from "../assets/img/help/8.png";
import image9 from "../assets/img/help/9.png";
import image10 from "../assets/img/help/10.png";
import image11 from "../assets/img/help/11.png";
import image12 from "../assets/img/help/12.png";
import image13 from "../assets/img/help/13.png";
import image14 from "../assets/img/help/14.png";


import "../styles/help.css";

const Help = () => {
  const images = [
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
    image8,
    image9,
    image10,
    image11,
    image12,
    image13,
    image14,
  ];
  return (
      <Slider images={images} />
  );
};

export default Help;
